import DialogType from "../DialogType";
import {LoginType} from "../../models/LoginType";
import FunctionHelper from "../../helper/FunctionHelper";

class DialogDefault {
	private _parameter: Map<DialogType, any>;
	private static _instance: DialogDefault;
	private defaultParameters: Map<DialogType, any>;

	private constructor() {
		this.defaultParameters = new Map<DialogType, any>();
		this._parameter = new Map<DialogType, any>([
			[
				DialogType.LOGIN, LoginType.fromJson({})
			]
		]);
	}

	public setParameter<T_PARAMETER_TYPE>(dialogType: DialogType, parameter: T_PARAMETER_TYPE) {
		this.defaultParameters.set(dialogType, parameter);
	}

	public getParameter<T_PARAMETER_TYPE>(
		dialogType: DialogType
	): T_PARAMETER_TYPE {
		let parameter: T_PARAMETER_TYPE | undefined = this.defaultParameters.get(dialogType);

		if (!FunctionHelper.exists(parameter)) {
			parameter = this._parameter.get(dialogType);
		}

		if (FunctionHelper.exists(parameter)) {
			return parameter!;
		}

		return {} as T_PARAMETER_TYPE;
	}

	get parameter(): Map<DialogType, any> {
		return this._parameter;
	}

	public static get instance(): DialogDefault {
		return FunctionHelper.applyValue(this._instance, (this._instance = new this()));
	}
}

export default DialogDefault.instance;